export default __webpack_public_path__ + "static/media/icon_facility_locker.f7c3018e.svg";